import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'NAVIGA TRA LE SEZIONI',
        description: 'Con questo menù ti muovi tra le sezioni del crea verifiche.',
        name: 'Menu',
        tutorialName: 'generale_menu'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'bottom',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: 25,
        yOffset: 3
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: 75,
        yOffset: 3
    },
    autoOpen: true
};
